import React from 'react';
import classnames from 'classnames';
import './ErrorMessage.scss';

const DISPLAY_TYPES = {
  BOX: 'box',
  TRIANGLE: 'triangle',
};

type DisplayType = 'box' | 'triangle';

type Props = {
  displayType?: DisplayType;
  error?: string;
  className?: string;
};

const ErrorMessage = (props: Props) => {
  const { error, className } = props;
  const displayType = props.displayType || DISPLAY_TYPES.BOX;

  if (!error) {
    return null;
  }

  const classList = classnames('error-message', className, {
    'error-message--box': displayType === DISPLAY_TYPES.BOX,
    'error-message--triangle': displayType === DISPLAY_TYPES.TRIANGLE,
  });

  if (displayType === DISPLAY_TYPES.BOX) {
    return <div className={classList}>{error}</div>;
  }

  return (
    <div className={classList}>
      <i className="fas fa-exclamation-triangle" />
      <span className="error-message__text">{error}</span>
    </div>
  );
};

export default ErrorMessage;
